import { render, staticRenderFns } from "./SwipeImage.vue?vue&type=template&id=69893d06&scoped=true&"
import script from "./SwipeImage.vue?vue&type=script&lang=js&"
export * from "./SwipeImage.vue?vue&type=script&lang=js&"
import style0 from "./SwipeImage.vue?vue&type=style&index=0&id=69893d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69893d06",
  null
  
)

export default component.exports